import React, { useState, useCallback, useEffect } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

var toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction
  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["clean"], // remove formatting button
];

export default function TextEditor({
  value: propsValue,
  onChange: propsOnChange,
  content: propsContent,
  submit: propsOnSubmit,
  onClickBlur: propsOnClickBlur,
}) {
  const [quill, setQuill] = useState(null);

  const updateQuill = (quill, content) => {
    if (typeof content === "string") {
      if (content.startsWith("{")) {
        quill.setContents(JSON.parse(content));
      } else {
        quill.setText(content);
      }
    } else {
      quill.setContents(content);
    }
  };

  // useEffect(() => {
  //     if(quill != null) {
  //       updateQuill(quill, propsContent);
  //     }

  // }, //eslint-disable-next-line
  //  [propsContent])

  useEffect(() => {
    if (quill === null) return;
    const handler = () => {
      if (propsOnChange) {
        propsOnChange(quill.getContents());
      }
    };
    quill.on("text-change", handler);
    return () => {
      quill.off("text-change", handler);
    };
    // eslint-disable-next-line
  }, [quill]);

  useEffect(() => {
    if (quill === null) return;
    quill.on("selection-change", function (range, oldRange, source) {
      if (range === null && oldRange !== null) {
        if (propsOnClickBlur) propsOnClickBlur();
      } else if (range !== null && oldRange === null) return;
    });
    // eslint-disable-next-line
  }, [quill]);

  const wrapperRef = useCallback((wrapper) => {
    if (wrapper === null) return;
    wrapperRef.innerHTML = "";
    const editor = document.createElement("div");
    wrapper.append(editor);
    const quill = new Quill(editor, {
      modules: {
        toolbar: toolbarOptions,
      },
      theme: "snow",
    });
    setQuill(quill);
    quill.focus();
    updateQuill(quill, propsContent);
    // Prevent close on toolbar click
    quill.getModule("toolbar").container.addEventListener("mousedown", (e) => {
      e.preventDefault();
    });
    // eslint-disable-next-line
  }, []);
  return <div ref={wrapperRef}></div>;
}
